import { createAction, props } from '@ngrx/store';

export const setProposal = createAction('[PROPOSAL] Set Proposal', props<{ proposal }>());

export const editProposal = createAction(
  '[PROPOSAL] Edit Proposal',
  props<{ id: number; proposal }>()
);
